import __request__ from "routing/request";
export function stats(adapterId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/stats/${adapterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(sort = "key", adapterId, page = 1, per_page = 50, order = "asc", query, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/${adapterId}`, null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, adapterId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/${adapterId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteAllByDataAdapterId(adapterId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/${adapterId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(adapterId, entryId, JSONbody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/${adapterId}/${entryId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(adapterId, entryId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.lookup/lookup/adapters/mongodb/${adapterId}/${entryId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
